
























































































































import ConfirmModal from '@/components/common/ConfirmModal.vue';
import DatePicker from '@/components/form/DatePicker.vue';
import RichText from '@/components/form/RichText.vue';
import CreateCampaignMutation from '@/graphql/mutations/createCampaign.gql';
import QuoteQuery from '@/graphql/queries/quote.gql';
import { API_HOST, getAuthHeader, request } from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ConfirmModal,
    DatePicker,
    RichText,
  },
})
export default class CreateCampaign extends Vue {
  public minDate = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000); // 2 weeks
  public maxDate = new Date(Date.now() + 6 * 31 * 24 * 60 * 60 * 1000); // Approx. 6 months

  public title: string = '';
  public story: string = '';
  public endDate: Date | null = null;
  public isError: boolean = false;
  public errorMessage: string = '';
  public canCreateCampaign = false;
  public heroImage: any = null;
  public isSubmitting: boolean = false;
  public id!: string;
  public modalVisible: boolean = false;
  public quote: {
    id: string;
    price: number;
    isAccepted: boolean;
    state: string;
    campaign?: {
      id: string;
      name: string;
      goal: number;
      raised: number;
      endDateTime: Date;
    };
  } = {} as any;

  public mounted() {
    this.id = this.$route.query.id;

    request(QuoteQuery, { id: this.id })
      .then(response => {
        if (!response || !response.data) {
          console.error('No clinic returned');
        }

        this.quote = response.data.quote;

        if (!this.quote) {
          this.$router.push('/');
        }

        if (
          this.quote.state === 'drafted' &&
          this.$store.getters['auth/authenticated']
        ) {
          this.canCreateCampaign = true;
        }

        if (
          this.quote.state === 'campaigning' &&
          this.quote.campaign !== undefined
        ) {
          this.redirectToCampaign(this.quote.campaign.id);
        }
      })
      .catch(console.error);
  }

  public requestCreateCampaign() {
    this.isSubmitting = true;
    this.modalVisible = false;

    if (this.canCreateCampaign) {
      this.createCampaign()
        .then(({ data, errors }: any) => {
          if (errors && errors.length) {
            throw errors;
          }
          this.redirectToCampaign(data.createCampaign.id);
        })
        .catch(errors => {
          this.isError = true;
          this.isSubmitting = false;
          this.errorMessage = this.parseErrors(errors);
        });
    }
  }

  public heroImageChange(event: any) {
    this.heroImage = event.target.files[0];
  }

  public formatPrice(price: number) {
    return (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  private redirectToCampaign(id: string) {
    this.$router.push({ name: 'showCampaign', query: { id } });
  }

  private parseErrors(errors: any) {
    const err = errors && errors[0];
    if (!err) {
      return 'Something went wrong. Please try again later.';
    }

    const msg = err.message || err;
    return typeof msg === 'string'
      ? msg
      : msg.error || 'Something went wrong. Please try again later.';
  }

  private async createCampaign() {
    const name = this.title;
    const description = this.story;
    const quoteId = this.id;
    const goal = this.quote.price;
    const endDateTime = this.endDate && this.endDate.toString();
    const formData = new FormData();
    formData.append('hero', this.heroImage);

    if (
      this.title.length < 1 ||
      this.story.length < 1 ||
      !this.endDate ||
      !this.heroImage
    ) {
      throw [new Error('Please fill in all fields.')];
    }

    this.isError = false;
    const { data: createResponse, errors } = await request(
      CreateCampaignMutation as any,
      {
        name,
        description,
        quoteId,
        goal,
        endDateTime,
      }
    );

    if (errors && errors.length) {
      throw errors;
    }

    const uploadResult = await fetch(
      `${API_HOST}/campaign/${createResponse.createCampaign.id}/hero`,
      {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: getAuthHeader(),
        },
      }
    );

    if (!uploadResult.ok) {
      throw new Error(uploadResult.statusText);
    }

    return { data: createResponse, errors };
  }
}
